import { AddButton } from '@gripp/shared-ui';
import { useNavigate, useParams } from 'react-router-dom';
import { useAssetRouting } from '../../../assets/assetRouteContext';

type NewAlertHeaderActionProps = {
  /**
   * Runs before navigation. For panel route handoffs, prefer
   * `slideLayout.prepareSlideTransition(SlideAction.NEXT)` plus
   * `getNavigationState` over awaiting `onSlideChange`, so old and new layouts
   * can animate concurrently.
   */
  onBeforeNavigate?: () => void | Promise<void>;
  getNavigationState?: () => Record<string, unknown> | undefined;
  accessibilityLabel?: string;
};

export const NewAlertHeaderAction = ({
  onBeforeNavigate,
  getNavigationState,
  accessibilityLabel,
}: NewAlertHeaderActionProps) => {
  const navigate = useNavigate();
  const { assetId = '', routineId = '' } = useParams();
  const { basePath } = useAssetRouting(assetId);

  const handlePress = async () => {
    const navigationState = getNavigationState?.();
    await onBeforeNavigate?.();
    navigate(
      `${basePath}/routines/${routineId}/alerts/new`,
      navigationState ? { state: navigationState } : undefined
    );
  };

  return (
    <AddButton
      variant="header"
      onPress={() => void handlePress()}
      accessibilityLabel={accessibilityLabel}
    />
  );
};
